<app-wrapper size="xl" isFitWithSmallScreen="true">
  <app-content-row>
    <app-card-content [showSeparator]="true">
      <app-card-content-head>
        <mat-icon class="card-content-head-icon">search</mat-icon>
        基本検索
      </app-card-content-head>
      <app-card-content-nav [menus]="tabMenus" (menuClick)="onTabMenuClick($event)"></app-card-content-nav>
      <app-wrapper size="fluid">
        <app-content-row>
          <!-- フリーワード検索フォーム -->
          <div class="search-free-container">
            <div class="flex flex-wrap gap-4 max-w-screen-md mb-6">
              <div class="flex-1 max-w-[200px]">
                <mat-form-field appearance="outline" class="w-full [&_.mat-form-field-wrapper]:pb-0">
                  <mat-label>科目</mat-label>
                  <mat-select (selectionChange)="onChangeValues()" [(value)]="selectedSubjectId">
                    <mat-option *ngFor="let subject of subjects$ | async" [value]="subject.id">
                      {{ subject.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="flex gap-1 flex-1 min-w-[250px]">
                <div class="flex-1 max-w-[200px]">
                  <mat-form-field appearance="outline" class="w-full [&_.mat-form-field-wrapper]:pb-0 [&_.mat-form-field-infix]:w-auto">
                    <mat-label>開始年度</mat-label>
                    <mat-select (selectionChange)="onChangeValues()" [formControl]="startYearFormControl">
                      <mat-option *ngFor="let year of selectableYears" [value]="year">{{ year }}年</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="flex items-center">
                  <div class="mat-title mb-0">〜</div>
                </div>

                <div class="flex-1 max-w-[200px]">
                  <mat-form-field appearance="outline" class="w-full [&_.mat-form-field-wrapper]:pb-4 [&_.mat-form-field-infix]:w-auto">
                    <mat-label>終了年度</mat-label>
                    <mat-select (selectionChange)="onChangeValues()" [formControl]="endYearFormControl">
                      <mat-option *ngFor="let year of selectableYears" [value]="year">{{ year }}年</mat-option>
                    </mat-select>
                    <mat-error *ngIf="endYearFormControl.hasError('min')">開始年度以上の値を設定してください</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div>
              <div class="mb-2">
                <div class="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
                  <mat-form-field appearance="outline" class="freeword-field w-full md:flex-1 [&_.mat-form-field-wrapper]:pb-0">
                    <mat-label>フリーワード（複数可）</mat-label>
                    <input matInput [formControl]="freewordFormControl" />
                  </mat-form-field>

                  <div class="flex items-center md:justify-center mb-2 md:mb-0 py-2">
                    <mat-radio-group [formControl]="operatorFormControl" (change)="onChangeValues()">
                      <ng-container *ngFor="let operator of operators">
                        <mat-radio-button class="mr-3" [value]="operator.id" [matTooltip]="operator.tooltip" matTooltipPosition="above">
                          {{ operator.name }}
                        </mat-radio-button>
                      </ng-container>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <p class="text-xs text-sub leading-[1.5]">
                ※ 検索の対象は、掲載中のWordファイル（問題、解答・解説）内のデータです。
              </p>
            </div>
          </div>
        </app-content-row>
      </app-wrapper>
    </app-card-content>
  </app-content-row>
</app-wrapper>

<!-- 下部UI -->
<div class="buttons-sub-container-spacer"></div>
<div class="buttons-sub-container">
  <app-wrapper size="xl">
    <div class="action-buttons-container">
      <div class="count-container">
        <div class="font-bold text-lg md:text-lg">検索結果</div>
        <div class="font-bold text-lg md:text-2xl text-primary">
          {{ (matchedProblemCount$ | async) == null ? '-' : (matchedProblemCount$ | async) }}
        </div>
        <div class="font-bold text-lg md:text-lg">件</div>

        <div [@inOut]="problemCountSearching$ | async">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
        <span class="spacer"></span>
      </div>
      <span class="spacer hidden md:block"></span>
      <div class="flex md:block mt-4 md:mt-0">
        <button mat-flat-button class="mr-2 bg-gray-50 text-primary font-normal grow w-1/2 md:w-36" (click)="resetForms()">
          条件をリセット
        </button>
        <button
          mat-flat-button
          class="grow w-1/2 md:w-36"
          color="primary"
          (click)="showSearchResultView()"
          [disabled]="(problemCountSearching$ | async) || matchedProblemCount === 0"
        >
          結果を表示
        </button>
      </div>
    </div>
  </app-wrapper>
</div>
<!-- 下部UI -->

<ng-template #loading>
  <div class="progress-48">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
</ng-template>
